
export default {
  namespaced: true,
  state: {
    user: {}
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/userStore.js